import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { AuthProvider as OidcProvider } from "react-oidc-context";
import { env } from "../env.js";
import { isZitadel, zitadelConfig } from "./config.js";

/**
 * Mounts the provider this build talks to. Only one is ever rendered, chosen by
 * REACT_APP_AUTH_PROVIDER (see ./config.js).
 */
export const AppAuthProvider = ({ children }) => {
  if (isZitadel) {
    return <OidcProvider {...zitadelConfig}>{children}</OidcProvider>;
  }

  return (
    <Auth0Provider
      domain={env.REACT_APP_DOMAIN}
      clientId={env.REACT_APP_CLIENT_ID}
      redirectUri={`${window.location.origin}/admin`}
      audience={env.REACT_APP_AUDIENCE}
    >
      {children}
    </Auth0Provider>
  );
};
